module.exports = __webpack_public_path__ + "ee33935d2f9c90b85cd1b62b8a43b6e4.svg";